var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/logo2.png")},on:{"click":_vm.onClickIcon}}),_c('span',{staticClass:"header-text display-1"},[_vm._v(" Angel Investor  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }